import * as React from 'react';
import cx from 'classnames';

import { useDesktopClientOnly } from '../../../../utils/useDesktopClientOnly';
import { ThemeSentinel } from '../../../../components/ThemeSentinel/ThemeSentinel';

const LoadableBackgroundVideo = React.lazy(() =>
  import('../BackgroundVideo/BackgroundVideo').then((component) => ({
    default: component.BackgroundVideo,
  })),
);

import * as cs from './Background.module.css';

interface Props {
  page: string;
}

export const Background = ({ page }: Props) => {
  const desktopRendered = useDesktopClientOnly();

  const mainPage = page === 'main';

  return (
    <div className={cx(cs.videoBg, { [cs.mainPage]: mainPage })} aria-hidden>
      <div className={cs.imageBg} />

      {desktopRendered && (
        <React.Suspense>
          <LoadableBackgroundVideo mainPage={mainPage} />
        </React.Suspense>
      )}
      {mainPage && <ThemeSentinel />}
    </div>
  );
};
